import Head from 'next/head';
import sanitizeHTML from 'lib/sanitizeHTML';
import { getShareLink, getVideoLink, getOEmbedLink } from 'lib/community';

import { CommunityShotItem } from 'types/community';

type ShotMetatagsProps = {
  shotItem: CommunityShotItem;
};

export default function ShotMetatags({ shotItem }: ShotMetatagsProps) {
  const description = sanitizeHTML(shotItem.description);
  const playerUrl = getVideoLink(shotItem);
  const url = `${getShareLink(shotItem)}`;

  // TODO: oembed links are going nowhere!
  // probably broke this with reworking for outverse
  return (
    <Head>
      <title>
        {shotItem.title} by {shotItem.username} - made with Rive
      </title>
      <meta name="description" content={description} />

      <meta name="twitter:card" content="player" />
      <meta name="twitter:site" content="@rive_app" />
      <meta name="twitter:domain" content="rive.app" />
      <meta name="twitter:title" content={shotItem.title} />
      <meta name="twitter:description" content={description} />
      <meta
        name="twitter:image"
        content={`${shotItem.watermarkThumbnailUrl ?? shotItem.thumbnailUrl}`}
      />
      <meta name="twitter:player" content={playerUrl} />
      <meta name="twitter:player:width" content={`${shotItem.videoWidth}`} />
      <meta name="twitter:player:height" content={`${shotItem.videoHeight}`} />

      <meta property="og:type" content="video.other" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:url" content={`${url}`} />
      <meta property="og:site_name" content="Rive" />
      <meta property="og:title" content={shotItem.title} />
      <meta property="og:description" content={description} />
      <meta
        property="og:image"
        content={`${shotItem.watermarkThumbnailUrl ?? shotItem.thumbnailUrl}`}
      />
      <meta property="og:image:type" content="image/png" />
      <meta
        property="og:image:secure_url"
        content={`${shotItem.watermarkThumbnailUrl ?? shotItem.thumbnailUrl}`}
      />
      <meta property="og:image:width" content={`${shotItem.videoWidth}`} />
      <meta property="og:image:height" content={`${shotItem.videoHeight}`} />
      <meta property="og:video" content={playerUrl} />
      <meta property="og:video:secure_url" content={playerUrl} />
      <meta property="og:video:type" content={'text/html'} />
      <meta property="og:video:width" content={`${shotItem.videoWidth}`} />
      <meta property="og:video:height" content={`${shotItem.videoHeight}`} />

      <link
        rel="alternative"
        type="application/json+oembed"
        href={getOEmbedLink(shotItem)}
        title={`${shotItem.title} oEmbed Profile`}
      />
    </Head>
  );
}
